<template>
  <v-app>
    <the-header />

    <v-main>
      <transition name="fade" mode="out-in">
        <router-view :key="$route.path"></router-view>
      </transition>
    </v-main>

    <the-footer />

    <the-loading />
  </v-app>
</template>

<script>
import TheHeader from "@/containers/TheHeader";
import TheFooter from "@/containers/TheFooter";
import TheLoading from "@/components/TheLoading";

export default {
  name: "TheContainer",
  components: {
    TheHeader,
    TheFooter,
    TheLoading,
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
